import {
  CdkVirtualForOf,
  CdkVirtualScrollViewport,
} from '@angular/cdk/scrolling';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  ViewChild,
  inject,
} from '@angular/core';
import { Store } from '@ngxs/store';
import { GroupedUnassignedUserDataV2 } from '@wilson/interfaces';
import {
  ShiftTimelineDataState,
  ShiftTimelineSettingsState,
  ShiftTimelineState,
  ShiftTimelineUnassignedRegionState,
} from '@wilson/shift-timeline/state';
import { Subscription } from 'rxjs';

@Component({
  selector: 'wilson-unassigned-activities-row',
  templateUrl: './unassigned-activities-row.component.html',
  styleUrls: ['./unassigned-activities-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UnassignedActivitiesRowComponent
  implements AfterViewInit, OnDestroy
{
  private readonly cdRef = inject(ChangeDetectorRef);

  private store = inject(Store);

  @ViewChild('viewport')
  viewport!: CdkVirtualScrollViewport;

  @ViewChild(CdkVirtualForOf)
  cdkVirtualForOf!: CdkVirtualForOf<GroupedUnassignedUserDataV2[]>;

  @Input() rows!: GroupedUnassignedUserDataV2[];

  protected maxHeight$ = this.store.select(
    ShiftTimelineDataState.maxUnassignedRowHeightPx,
  );

  protected defaultRowHeight = this.store.selectSnapshot(
    ShiftTimelineSettingsState.defaultRowHeight,
  );

  protected isUnassignedRegionExpanded$ = this.store.select(
    ShiftTimelineUnassignedRegionState.isUnassignedRegionExpanded,
  );

  protected defaultUnassignedSectionHeight$ = this.store.select(
    ShiftTimelineSettingsState.defaultUnassignedSectionHeight,
  );

  protected frameLength$ = this.store.select(ShiftTimelineState.frameLength);
  protected visibleDaysRange$ = this.store.select(
    ShiftTimelineDataState.visibleDateRange,
  );
  protected timeframe$ = this.store.select(ShiftTimelineDataState.timeframe);

  private subscriptions = new Subscription();

  trackByIds(_: number, data: GroupedUnassignedUserDataV2): string {
    const combinedString = [...data.jobs, ...data.services]
      .flatMap((view) => view.id)
      .join('');
    return combinedString;
  }

  ngAfterViewInit(): void {
    const forceRerenderSub = this.cdkVirtualForOf.viewChange.subscribe(() => {
      setTimeout(() => {
        this.cdRef.detectChanges();
      });
    });
    this.subscriptions.add(forceRerenderSub);
  }

  ngOnDestroy(): void {
    this.subscriptions?.unsubscribe();
  }
}
